<table>
  <thead>
      <th class="subtable string">{{'global.finca' | translate}}</th>
      <th class="subtable number">{{'gestionRoyalties.productor.cultivos.superficie' | translate}} ({{ _unidadesMedida.superficie.symbol }})</th>
      <th class="subtable number">{{'gestionRoyalties.productor.cultivos.importe' | translate}} ({{ _unidadesMedida.divisas.symbol }})</th>
      <th class="subtable number">{{'gestionRoyalties.productor.cultivos.plantas' | translate}} ({{ _unidadesMedida.nPlantas.symbol }})</th>
      <th class="subtable number">{{'gestionRoyalties.productor.cultivos.importe' | translate}} ({{ _unidadesMedida.divisas.symbol }})</th>
      <th class="subtable number">{{'gestionRoyalties.productor.cultivos.pesoProducido' | translate}} ({{ _unidadesMedida.peso.symbol }})</th>
      <th class="subtable number">{{'gestionRoyalties.productor.cultivos.importe' | translate}} ({{ _unidadesMedida.divisas.symbol }})</th>
  </thead>
  <tbody *ngFor="let cultivo of cultivosProductor; let i = index;">
    <tr>
      <td class="string">{{cultivo.desFinca}}</td>
      <td class="number">{{cultivo.sumaSuperficie | number : '1.2-2' : defaultLanguage }}</td>
      <td class="number">{{cultivo.calculo_Superficie_Fee | number : '1.2-2' : defaultLanguage}}</td>
      <td class="number">{{cultivo.sumaNPlantas | number : '1.2-2' : defaultLanguage }}</td>
      <td class="number">{{cultivo.calculo_NPlantas_Fee | number : '1.2-2' : defaultLanguage}}</td>
      <td class="number">{{cultivo.sumaKilos | number : '1.2-2' : defaultLanguage }}</td>
      <td class="number">{{cultivo.calculo_Kilos_Fee | number : '1.2-2' : defaultLanguage}}</td>
    </tr>
  </tbody>
  <tfoot *ngIf="_cultivos && _cultivos.length < 1">
      <tr>
        <td colspan="7">
          {{'global.noContent' | translate}}
        </td>
      </tr>
  </tfoot>
</table>
<app-paginator
        *ngIf="(_cultivos && _cultivos.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)" [hiddeItems]="true"></app-paginator>
